<div class="fullscreen">
  <div class="text-center logo">
    <a href="#">
      <img [src]="logoPath" alt="logo" />
    </a>
  </div>

  <div class="text-center d-flex flex-column justify-content-center main-content">
    <p class="mb-3" [innerHTML]="(fullscreenLoaderState$ | async)?.message"></p>

    <div class="pt-3">
      <sliqpay-dot-loader theme="primary"></sliqpay-dot-loader>
    </div>
  </div>
</div>
